import React from 'react';
import { Countdown } from './Countdown';
export function UrgencySection() {
  return <section className="w-full bg-ink-900 px-4 py-14 sm:px-5 sm:py-20" data-id="element-200" data-mp="2sit1phcgikic">
      <div className="mx-auto max-w-3xl text-center" data-id="element-201" data-mp="2sgq0s29rn6yu">
        <h2 className="text-xl font-extrabold uppercase leading-tight text-white sm:text-3xl" data-id="element-202" data-mp="36azequkbcbdk">
          ⏰ Precio de lanzamiento — cierra pronto
        </h2>

        <div className="mt-8" data-id="element-203" data-mp="3g856m50r46eu">
          <Countdown data-id="element-204" data-mp="3g72i23qwig23" />
        </div>

        <p className="mt-6 text-sm font-bold text-yellow-400 sm:text-base" data-id="element-205" data-mp="3g6aoeygv6seg">
          ⚠️ Después sube $8.000 ARS. No vuelve al precio actual.
        </p>

        <div className="mt-8 rounded-2xl border border-red-500/25 bg-ink-800 p-5 sm:p-6" data-id="element-206" data-mp="3p93fp1q1r44a">
          <div className="flex flex-wrap items-center justify-between gap-2 text-sm font-bold" data-id="element-207" data-mp="3l6oxmju7c8e2">
            <span className="text-white" data-id="element-208" data-mp="1uu97d845ldid">
              🔴 Cupos al precio de lanzamiento
            </span>
            <span className="text-red-400" data-id="element-209" data-mp="1qtz2jys3kt53">Quedan pocos</span>
          </div>
          <div className="mt-4 h-3 w-full overflow-hidden rounded-full bg-ink-600" role="progressbar" aria-valuenow={68} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos al precio de lanzamiento tomados" data-id="element-210" data-mp="2sty0bj8x1el7">
            <div className="h-full w-[68%] rounded-full bg-brand-500" data-id="element-211" data-mp="37ikhlqi3sgf2" />
          </div>
          <p className="mt-3 text-xs text-gray-400 sm:text-sm" data-id="element-212" data-mp="37kdq7bca1app">
            68% de los cupos al precio de lanzamiento ya tomados.
          </p>
        </div>
      </div>
    </section>;
}